<template>
  <generic-container
    v-bind:title="this.name"
    icon="school"
    v-on:title_click="title_click"
    v-bind:searchable="true"
    v-bind:show_plus="true"
    v-on:filter="filter"
    v-on:add="add"
  >
    <div class="ui container" style="min-height: 150px">
      <div class="ui form">
        <div class="field">
          <label for>{{ $t("campaign") }}</label>
          <div class="ui selection dropdown" ref="campaign_dropdown">
            <input type="hidden" name="campaign" v-model="campaign" />
            <i class="dropdown icon"></i>
            <div class="default text">{{ $t("select one") }}</div>
            <div class="menu"></div>
          </div>
        </div>
        <div class="ui styled fluid accordion" ref="accordion">
          <div v-for="(person, index) in people" v-bind:key="index">
            <div class="title">
              <i class="dropdown icon"></i>
              {{ person.name }}
            </div>
            <div class="content">
              <div class="two fields">
                <div class="field">
                  <label for>{{ $t("name") }}</label>
                  <input type="text" name="name" v-model="people[index].name" />
                </div>
                <div class="field">
                  <label for>{{ $t("delete") }}</label>
                  <div
                    class="ui mini icon red button"
                    v-on:click="remove(person, index)"
                  >
                    <i class="trash icon"></i>
                  </div>
                </div>
              </div>

              <div class="ui list">
                <div
                  class="item"
                  v-for="(item, itmIdx) in items"
                  v-bind:key="itmIdx"
                >
                  <div class="fields">
                    <div class="field">
                      <label for>{{ $t("clothing") }}</label>
                      <strong>{{ people[index].items[itmIdx].name }}</strong>
                    </div>
                    <div class="one column wide field">
                      <label for>{{ $t("size 2") }}</label>
                      <input
                        type="text"
                        name="size_2"
                        v-model="people[index].items[itmIdx].size_2"
                      />
                    </div>
                    <div class="one column wide field">
                      <label for>{{ $t("size 4") }}</label>
                      <input
                        type="text"
                        name="size_4"
                        v-model="people[index].items[itmIdx].size_4"
                      />
                    </div>
                    <div class="one column wide field">
                      <label for>{{ $t("size 6") }}</label>
                      <input
                        type="text"
                        name="size_6"
                        v-model="people[index].items[itmIdx].size_6"
                      />
                    </div>
                    <div class="one column wide field">
                      <label for>{{ $t("size 8") }}</label>
                      <input
                        type="text"
                        name="size_8"
                        v-model="people[index].items[itmIdx].size_8"
                      />
                    </div>
                    <div class="one column wide field">
                      <label for>{{ $t("size 10") }}</label>
                      <input
                        type="text"
                        name="name"
                        v-model="people[index].items[itmIdx].size_10"
                      />
                    </div>
                    <div class="one column wide field">
                      <label for>{{ $t("size 12") }}</label>
                      <input
                        type="text"
                        name="name"
                        v-model="people[index].items[itmIdx].size_12"
                      />
                    </div>
                    <div class="one column wide field">
                      <label for>{{ $t("size 14") }}</label>
                      <input
                        type="text"
                        name="name"
                        v-model="people[index].items[itmIdx].size_14"
                      />
                    </div>
                    <div class="one column wide field">
                      <label for>{{ $t("size 16") }}</label>
                      <input
                        type="text"
                        name="name"
                        v-model="people[index].items[itmIdx].size_16"
                      />
                    </div>
                    <div class="one column wide field">
                      <label for>{{ $t("size s") }}</label>
                      <input
                        type="text"
                        name="name"
                        v-model="people[index].items[itmIdx].size_s"
                      />
                    </div>
                    <div class="one column wide field">
                      <label for>{{ $t("size m") }}</label>
                      <input
                        type="text"
                        name="name"
                        v-model="people[index].items[itmIdx].size_m"
                      />
                    </div>
                    <div class="one column wide field">
                      <label for>{{ $t("size l") }}</label>
                      <input
                        type="text"
                        name="name"
                        v-model="people[index].items[itmIdx].size_l"
                      />
                    </div>
                    <div class="one column wide field">
                      <label for>{{ $t("size xl") }}</label>
                      <input
                        type="text"
                        name="name"
                        v-model="people[index].items[itmIdx].size_xl"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </generic-container>
</template>

<script>
import moment from "moment";
import GenericContainer from "@/components/GenericContainer";
import { local_api, toast } from "@/utils";
// import MeassurementModal from "../components/ClothingMeassurementModal";

export default {
  name: "Settings",
  props: [],
  mounted() {
    let vm = this;
    local_api(this, "post", "/clothing_meassurement/do-get-configuration")
      .then((conf) => {
        if (conf && conf.setup && conf.setup.campaigns) {
          let vls = conf.setup.campaigns.map((c) => {
            return { value: c.id, name: c.name };
          });
          window
            .jQuery(this.$refs.campaign_dropdown)
            .dropdown({
              onChange(value) {
                let trgt = conf.setup.campaigns.find((n) => n.id == value);
                vm.items = trgt.items.split(",");
              }
            })
            .dropdown("setup menu", { values: vls });
        }
      })
      .catch((err) => {
        toast(this.$el, "error", err);
      });

    window.jQuery(this.$refs.accordion).accordion();
  },
  components: {
    "generic-container": GenericContainer
  },
  data() {
    return {
      name: this.$t("take ") + moment().format("LLLL"),
      campaign: "",
      people: [],
      items: []
    };
  },
  methods: {
    add() {
      this.people.push({
        name: this.$i18n.t("new"),
        items: this.items.map((i) => {
          return { name: i };
        })
      });
    },
    title_click() {
      let vm = this;
      this.$alertify.prompt(this.$t("enter take name"), this.name, function(
        element,
        value
      ) {
        vm.name = value;
      });
    },
    filter(query) {
      console.log(query);
    },
    remove(person, index) {
      this.people.splice(index, 1);
    }
    // destroy() {
    //   this.meassurement_modals = [];
    // }
  },
  computed: {}
};
</script>

<style></style>
